import _ from 'lodash';

export default function selector(storeState) {
    const user = _.get(storeState, `profilePage.user`, undefined);

    const orgId = _.get(user, 'attr.organization', undefined);
    const adPresets = _.get(storeState, 'resources.adPresets', undefined);

    const adPresetsAttr = _.map(_.keys(adPresets), adPresetId => {
        return adPresets[adPresetId].attr;
    });

    const isUpdatingPreferences = _.get(storeState, `profilePage.isUpdatingPreferences`, false);

    const out = {
        user,
        orgId,
        adPresets: adPresetsAttr,
        ownOrganization: _.get(storeState, 'profilePage.organization'),
        isUpdatingPreferences,
    };

    return out;
}
